import { defineComponent, onMounted, ref, toRefs, watch } from '@vue/composition-api';
import draggable from 'vuedraggable';
import DpButton from '../button/Button.vue';
import DpIcon from '../icon/Icon.vue';
export default defineComponent({
    name: 'DpDraggableList',
    components: {
        draggable,
        DpIcon,
        DpButton,
    },
    props: {
        options: { type: Array, default: () => [] },
    },
    setup(props, { emit }) {
        const { options } = toRefs(props);
        const displayedOptions = ref([]);
        const pushChanges = () => {
            emit('change', displayedOptions.value);
        };
        const remove = (index) => {
            displayedOptions.value.splice(index, 1);
            pushChanges();
        };
        const updateListFromProps = () => {
            displayedOptions.value = options.value;
        };
        watch(options, updateListFromProps);
        onMounted(updateListFromProps);
        return {
            displayedOptions,
            remove,
            pushChanges,
        };
    },
});
